import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import StatusBar from '../common/StatusBar'
import {
    Card,
    CardBlock,
    CardHeader,
    Progress,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button
} from 'reactstrap';

class CasoBox extends Component{
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    dropActions() {
        return (
        <div className="d-flex justify-content-end">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    <Button className="btn btn-outline-secondary">
                        Acciones <i className="fa fa-chevron-down" />
                    </Button>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
                    <DropdownItem><i className="fa fa-bell-o"></i> Updates<Badge color="info">42</Badge></DropdownItem>
                    <DropdownItem><i className="fa fa-envelope-o"></i> Messages<Badge
                        color="success">42</Badge></DropdownItem>
                    <DropdownItem><i className="fa fa-tasks"></i> Tasks<Badge color="danger">42</Badge></DropdownItem>
                    <DropdownItem><i className="fa fa-comments"></i> Comments<Badge
                        color="warning">42</Badge></DropdownItem>
                    <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
                    <DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem>
                    <DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
                    <DropdownItem><i className="fa fa-usd"></i> Payments<Badge
                        color="secondary">42</Badge></DropdownItem>
                    <DropdownItem><i className="fa fa-file"></i> Projects<Badge
                        color="primary">42</Badge></DropdownItem>
                    <DropdownItem divider/>
                    <DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem>
                    <DropdownItem><i className="fa fa-lock"></i> Logout</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        );
    }
    render(){
        var url = "/casos/" + this.props.caso.id;
        return(
            <Card className={this.props.caso.status == 2 ?  "casoCard status-text-1-back" : "casoCard"}>
                <CardBlock>
                    {/*
                    <span className="float-right mt-2">
                        <i className="fa fa-comment-o text-muted" />
                    </span>
                    */}
                    <Link className="panel-block" to={url}>
                        <h3>{this.props.caso.title}</h3>
                    </Link>
                    <StatusBar status={this.props.caso.status} partialDelivery={this.props.caso.partial_delivery} />
                    <Link className="panel-block" to={url}>
                        <span className="btn btn-primary float-md-right go-caso">Ver caso</span>
                    </Link>
                    <div className="float-md-right dropdown-caso">
                        {/* this.dropActions() */}
                    </div>
                </CardBlock>
            </Card>
        )
    }
}
export default CasoBox;


// WEBPACK FOOTER //
// ./resources/assets/js/components/dashboard/CasoBox.jsx